import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const Item = (props) => {
    const getValue = () => (props.fmtValue) ? props.fmtValue : props.value;

    if (props.checkNull) {
        return (
            <>
                {(props.value) !== null
                    ? <Typography>{props.name}: {getValue()}</Typography>
                    : null
                }
            </>
        );
    }
    else {
        return (
            <Typography>{props.name}: {props.value}</Typography>
        );
    }
};

Item.propTypes = {
    checkNull: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    fmtValue: PropTypes.string,
};

Item.defaultProps = {
    checkNull: false,
};

export default Item;
